import { ManagerDto } from '../dtos/manager-dto';

export type MutableManager = {
  -readonly [Value in keyof Manager]: Manager[Value];
};

export class Manager {
  readonly id: string;
  readonly firstname: string;
  readonly lastname: string;
  readonly email: string;

  constructor(dto: ManagerDto) {
    this.id = dto.sub;
    this.firstname = dto.given_name;
    this.lastname = dto.family_name;
    this.email = dto.email;
  }
}
